'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Field = require('./Field.scss');

var _Field2 = _interopRequireDefault(_Field);

var _constants = require('../../shared/constants');

var _ChevronLeft = require('../../components/Svg/ChevronLeft');

var _ChevronLeft2 = _interopRequireDefault(_ChevronLeft);

var _ExclamationMark = require('../../components/Svg/ExclamationMark');

var _ExclamationMark2 = _interopRequireDefault(_ExclamationMark);

var _Panel = require('../../components/Panel/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _WixStyles = require('../../shared/WixStyles/WixStyles');

var _WixStyles2 = _interopRequireDefault(_WixStyles);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _Time = require('@wix/wixrest-utils/dist/Time');

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        _initialiseProps.call(_this);

        var isMobile = props.isMobile,
            value = props.value,
            defaultValue = props.defaultValue,
            timezone = props.timezone;

        _this.uniqueId = _this._generateUniqueId();
        var deviceType = isMobile === true ? 'mobile' : typeof Wix !== 'undefined' ? Wix.Utils.getDeviceType() : 'desktop';

        _this.state = {
            isOpen: false,
            isPopup: true,
            popupCount: 0,
            panelReady: false,
            deviceType: deviceType,
            openOnClick: false,
            nonSupportMobileValue: _Time2.default.serializeDate(value || defaultValue, timezone)
        };
        return _this;
    }

    _class.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        if (typeof Wix !== 'undefined') {
            this._getWixStyleId().then(function (wixStyleId) {
                _this2.wixStyleId = wixStyleId;
                (0, _WixStyles2.default)(_constants.FRAME_TYPES.FIELD_FRAME, _this2.props.type, _this2._getWixParams(), _this2.props.isHebrew, _this2.wixStyleId);
            });
        }
    };

    _class.prototype.componentDidMount = function componentDidMount() {
        if (!this._isMobile()) {
            var timeoutTime = _constants.MOUNT_TIMEOUT + Math.ceil(Math.random() * _constants.MOUNT_TIMEOUT);
            setTimeout(this._onMount, timeoutTime);
        } else {
            this.props.onLoad();
        }
        Wix.addEventListener(Wix.Events.DEVICE_TYPE_CHANGED, this._deviceTypeChange);
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.state.isOpen) {
            this._requestClosePanel();
        }
        clearTimeout(this.timeoutId);
        clearTimeout(this.errorTimeout);
    };

    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var isPopup = this.state.isPopup;

        var shouldOpenPopup = this._shouldOpenPopup(nextProps);

        if (nextProps.rtl !== this.props.rtl && !this._isMobile()) {
            this._reset();
        }

        if (shouldOpenPopup !== isPopup) {
            this.setState({ isPopup: shouldOpenPopup }, function () {
                _this3._reset();
            });
        }
        if (!_lodash2.default.isEqual(this._getWixParams(), this._getWixParams(nextProps))) {
            (0, _WixStyles2.default)(_constants.FRAME_TYPES.FIELD_FRAME, nextProps.type, this._getWixParams(nextProps));
        }

        if (nextProps.id !== this.props.id) {
            this.uniqueId = this._generateUniqueId();
        }
    };

    _class.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.disabled && !prevProps.disabled) {
            this._requestClosePanel();
        }
    };

    _class.prototype.render = function render() {
        var _this4 = this;

        var _props = this.props,
            tabIndex = _props.tabIndex,
            dataHook = _props.dataHook;

        var fieldClassName = this._getFieldClassName();
        var innerFieldClassName = this._getInnerFieldClassName();
        var panel = this._getPanel();
        var fieldContent = this._getFieldContent();
        var exclamation = this._getExclamation();
        var arias = this._getArias();

        return _react2.default.createElement(
            'div',
            { className: fieldClassName, ref: function ref(el) {
                    return _this4.el = el;
                }, tabIndex: -1, 'data-hook': dataHook },
            _react2.default.createElement(
                'div',
                _extends({ className: innerFieldClassName,
                    ref: function ref(el) {
                        return _this4.field = el;
                    },
                    onClick: this._onClick,
                    tabIndex: tabIndex,
                    onKeyDown: this._onKeyDown
                }, arias, {
                    'data-unique-id': this.uniqueId }),
                exclamation,
                fieldContent
            ),
            panel
        );
    };

    return _class;
}(_react2.default.Component);

_class.defaultProps = {
    placeholder: '',
    rtl: false,
    closeOthers: false,
    error: false,
    disabled: false,
    tabIndex: 0,
    zIndex: 1,
    timezone: _momentTimezone2.default.tz.guess(),
    onChange: function onChange() {},
    onOpen: function onOpen() {},
    onClose: function onClose() {},
    onLoad: function onLoad() {},
    onClick: function onClick() {}
};

var _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.focus = function () {
        if (_this5.field) {
            _this5.field.focus();
        }
    };

    this._getBlurCallback = function () {
        var _state = _this5.state,
            isOpen = _state.isOpen,
            panelReady = _state.panelReady;

        return isOpen && panelReady ? _this5._requestClosePanel : null;
    };

    this._getFieldClassName = function () {
        var _props2 = _this5.props,
            error = _props2.error,
            rtl = _props2.rtl,
            disabled = _props2.disabled,
            className = _props2.className;
        var isOpen = _this5.state.isOpen;

        return _constants.CLASSES.FIELD + ' ' + _Field2.default.wrapper + ' ' + (disabled ? _constants.CLASSES.FIELD_DISABLED + ' ' + _Field2.default.disabled : '') + ' ' + (error ? _constants.CLASSES.FIELD_ERROR : '') + ' ' + (className || '') + (' ' + (error ? _Field2.default.error : '') + ' ' + (rtl ? _Field2.default.rtl : '') + ' ' + (isOpen ? _constants.CLASSES.FIELD_OPEN + ' ' + _Field2.default.open : '')).replace(/\s+/g, ' ');
    };

    this._getInnerFieldClassName = function () {
        return _constants.CLASSES.FIELD_INNER + ' ' + _Field2.default.field + ' ' + (_this5._isMobile() ? _Field2.default.mobile : '');
    };

    this._getFieldContent = function () {
        var content = null;

        if (_this5._isMobile()) {
            content = _this5._getMobileFieldContent();
        } else {
            content = _this5._getDesktopFieldContent();
        }

        return content;
    };

    this._getDesktopFieldContent = function () {
        var label = _this5._getLabel();
        return [_react2.default.createElement(
            'div',
            { tabIndex: '-1', 'aria-live': 'polite', key: 'label', id: 'site-react-dropdown-label_' + _this5.uniqueId, className: _constants.CLASSES.FIELD_LABEL + ' ' + _Field2.default.label },
            label
        ), _this5._getCaret()];
    };

    this._getCaret = function () {
        return _react2.default.createElement(
            'div',
            { tabIndex: '-1', key: 'chevron', className: _constants.CLASSES.FIELD_CHEVRON + ' ' + _Field2.default.caret },
            _react2.default.createElement(_ChevronLeft2.default, { height: 11, width: 6 })
        );
    };

    this._getMobileFieldContent = function () {
        var type = _this5.props.type;

        var content = null;

        switch (type) {
            case _constants.COMPONENT_TYPES.SELECT_TYPE:
                content = _this5._getNativeSelect();
                break;
            case _constants.COMPONENT_TYPES.DATE_PICKER_TYPE:
                content = _this5._getNativeDatePicker();
                break;
        }

        return content;
    };

    this._getNativeSelect = function () {
        var _props3 = _this5.props,
            data = _props3.data,
            value = _props3.value,
            placeholder = _props3.placeholder;

        return [_react2.default.createElement(
            'select',
            { key: 'nativeselect', value: _lodash2.default.findIndex(data, { value: value }), onChange: function onChange(e) {
                    return _this5._onNativeChange(e, _constants.COMPONENT_TYPES.SELECT_TYPE);
                } },
            _react2.default.createElement(
                'option',
                { value: '-1', disabled: true },
                placeholder
            ),
            _lodash2.default.map(data, function (option, index) {
                return _react2.default.createElement(
                    'option',
                    { key: index, value: index, disabled: option.disabled },
                    option.name
                );
            })
        ), _this5._getCaret()];
    };

    this._getNativeDatePicker = function () {
        var _props4 = _this5.props,
            value = _props4.value,
            placeholder = _props4.placeholder,
            min = _props4.min,
            max = _props4.max,
            timezone = _props4.timezone,
            disabled = _props4.disabled;

        var defaultValue = value ? _Time2.default.serializeDate(value) : null;
        var minDate = min ? _Time2.default.serializeDate(min) : _Time2.default.serializeDate(_momentTimezone2.default.tz(new Date(), timezone));
        var maxDate = max ? _Time2.default.serializeDate(max) : undefined;
        var supportNative = _this5._supportNativeDate();

        return [supportNative ? _react2.default.createElement('input', { key: 'nativedatepicker', disabled: disabled, type: 'date', placeholder: placeholder, value: defaultValue || minDate, min: minDate, max: maxDate, onChange: function onChange(e) {
                return _this5._onNativeChange(e, _constants.COMPONENT_TYPES.DATE_PICKER_TYPE);
            } }) : _react2.default.createElement('input', { key: 'nativedatepicker', disabled: disabled, type: 'text', placeholder: placeholder, value: _this5.state.nonSupportMobileValue, onChange: _this5._onNativeNonSupportChange }), _this5._getCaret()];
    };

    this._onNativeChange = function (e, type) {
        var _props5 = _this5.props,
            data = _props5.data,
            onChange = _props5.onChange,
            value = _props5.value;

        var newValue = null;

        switch (type) {
            case _constants.COMPONENT_TYPES.SELECT_TYPE:
                var index = e.target.value;
                newValue = data[index].value;
                break;
            case _constants.COMPONENT_TYPES.DATE_PICKER_TYPE:
                newValue = e.target.value;
                break;
        }

        onChange(newValue || value);
    };

    this._onNativeNonSupportChange = function (e) {
        var _props6 = _this5.props,
            onChange = _props6.onChange,
            value = _props6.value,
            timezone = _props6.timezone;

        var newValue = e.target.value;
        _this5.setState({ nonSupportMobileValue: newValue }, function () {
            var result = _momentTimezone2.default.tz(newValue || value, timezone);

            if (result.isValid()) {
                result = _Time2.default.serializeDate(result);
            } else {
                result = null;
            }
            onChange(result);
        });
    };

    this._isMobile = function () {
        var ipadAsMobile = _this5.props.ipadAsMobile;

        var w = typeof window !== 'undefined' ? window : {};
        var isIpad = ipadAsMobile ? _lodash2.default.get(w, 'navigator.userAgent', '').match(/iPad/i) !== null : false;

        return _this5.state.deviceType === 'mobile' || isIpad;
    };

    this._supportNativeDate = function () {
        var type = _this5.props.type;

        var result = true;
        console.log('%c blabla! this.props', 'font-weight: bold; font-size: 16px;color: yellow;', _this5.props);

        if (typeof document !== 'undefined' && document.createElement && type === _constants.COMPONENT_TYPES.DATE_PICKER_TYPE) {
            var input = document.createElement('input');
            var notADateValue = 'not-a-date';

            input.setAttribute('type', 'date');
            input.setAttribute('value', notADateValue);
            result = input.value !== notADateValue;
        }

        return result;
    };

    this._getExclamation = function () {
        var error = _this5.props.error;

        return error ? _react2.default.createElement(_ExclamationMark2.default, { className: _Field2.default.exclamation }) : null;
    };

    this._shouldOpenPopup = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props;

        var element = (0, _jquery2.default)(_this5.el);
        var windowElem = (0, _jquery2.default)(window);
        var windowHeight = windowElem.outerHeight();
        var scrollTop = windowElem.scrollTop();
        var offset = _this5.el.getBoundingClientRect();
        var elementHeight = element.outerHeight();
        var elementBottom = offset.top - scrollTop + elementHeight;
        var panelHeight = _this5._calculatePanelHeight(props);

        return !_this5._isMobile() && (panelHeight === 0 || elementBottom + panelHeight > windowHeight);
    };

    this._calculatePanelHeight = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props;
        var type = props.type,
            data = props.data;

        var height = 0;

        switch (type) {
            case _constants.COMPONENT_TYPES.SELECT_TYPE:
                height = Math.min(data.length * _constants.LIST_ITEM_HEIGHT, _constants.MAX_PANEL_HEIGHT);
                break;
            case _constants.COMPONENT_TYPES.DATE_PICKER_TYPE:
                height = _constants.MAX_PANEL_HEIGHT;
                break;
        }

        return height;
    };

    this._getPanel = function () {
        var _props7 = _this5.props,
            type = _props7.type,
            value = _props7.value,
            rtl = _props7.rtl,
            zIndex = _props7.zIndex,
            defaultValue = _props7.defaultValue,
            locale = _props7.locale;

        var wixParams = _this5._getWixParams();
        var _state2 = _this5.state,
            isOpen = _state2.isOpen,
            isPopup = _state2.isPopup;


        return !isPopup && isOpen ? _react2.default.createElement(_Panel2.default, { ref: function ref(el) {
                return _this5.panel = el;
            },
            type: type,
            show: true,
            data: _this5._getData(),
            value: value,
            rtl: rtl,
            uniqueId: _this5.uniqueId,
            inline: true,
            defaultValue: defaultValue,
            onSelect: _this5._onPanelClose,
            onBlur: _this5._getBlurCallback(),
            onKeyUp: _this5._onPanelKeyUp,
            wixStyleId: _this5.wixStyleId,
            fieldFill: wixParams.fieldFill,
            fieldFont: wixParams.fieldFont,
            fieldColor: wixParams.fieldColor,
            zIndex: zIndex,
            locale: locale,
            fieldBorderWidth: wixParams.fieldBorderWidth }) : null;
    };

    this._getLabel = function () {
        var _props8 = _this5.props,
            placeholder = _props8.placeholder,
            value = _props8.value,
            valueToLabel = _props8.valueToLabel;

        var label = valueToLabel && value ? valueToLabel(value) : value || '';
        return label || placeholder;
    };

    this._onClick = function (e) {
        var _props9 = _this5.props,
            disabled = _props9.disabled,
            onClick = _props9.onClick;
        var _state3 = _this5.state,
            isOpen = _state3.isOpen,
            openOnClick = _state3.openOnClick;


        if (!disabled && !_this5._isMobile()) {
            if (isOpen) {
                _this5._requestClosePanel();
            } else {
                if (openOnClick) {
                    _this5._openPopup();
                }
                _this5._openPanel();
            }

            _this5._unFocusIfNeeded();
            e.preventDefault();
            e.stopPropagation();
        }

        onClick(!isOpen);
    };

    this._unFocusIfNeeded = function () {
        try {
            if (document.activeElement !== document.body) {
                document.activeElement.blur();
            }
        } catch (e) {
            console.warn('could not blur active element');
        }
    };

    this._onKeyDown = function (e) {
        var isOpen = _this5.state.isOpen;

        var keyCode = e.which;

        switch (keyCode) {
            case _constants.KEY_CODES.ENTER:
            case _constants.KEY_CODES.SPACE:
            case _constants.KEY_CODES.DOWN:
                if (!isOpen && !_this5._isMobile()) {
                    _this5._unFocusIfNeeded();
                    _this5._openPanel();
                    e.preventDefault();
                    return false;
                }
                break;
        }
    };

    this._onPanelKeyUp = function (e) {
        var keyCode = e.which;

        if (keyCode === _constants.KEY_CODES.ESC) {
            _this5._requestClosePanel();
        }
    };

    this._openPanel = function () {
        var isPopup = _this5.state.isPopup;
        var _props10 = _this5.props,
            value = _props10.value,
            defaultValue = _props10.defaultValue,
            onOpen = _props10.onOpen;
        var closeOthers = _this5.props.closeOthers;

        var data = _this5._getData();

        if (!_this5._isMobile()) {
            Wix.PubSub.subscribe(_this5._getMessageType(_constants.POPUP_EVENTS.PANEL_READY_MESSAGE), _this5._onPanelReady);
            if (isPopup && _this5.popupPromise) {
                _this5.popupPromise.then(function () {
                    Wix.PubSub.subscribe(_this5._getMessageType(_constants.POPUP_EVENTS.PANEL_CLOSING_MESSAGE), _this5._onPanelClose);
                    Wix.PubSub.publish(_this5._getMessageType(_constants.POPUP_EVENTS.OPEN_PANEL_MESSAGE), { data: data, value: value, defaultValue: defaultValue });
                    _this5.setState({ isOpen: true });

                    if (closeOthers) {
                        Wix.PubSub.publish(_constants.POPUP_EVENTS.ENFORCE_CLOSE_MESSAGE, { uniqueId: _this5.uniqueId });
                    }
                });
            } else {
                _this5.setState({ isOpen: true }, onOpen);
                (0, _jquery2.default)(document).on('keyup', _this5._onPanelKeyUp);

                if (closeOthers) {
                    Wix.PubSub.publish(_constants.POPUP_EVENTS.ENFORCE_CLOSE_MESSAGE, { uniqueId: _this5.uniqueId });
                }
            }
        }

        _this5._addDocumentClickListener();
    };

    this._getData = function () {
        var _props11 = _this5.props,
            type = _props11.type,
            data = _props11.data,
            min = _props11.min,
            max = _props11.max;

        var sentData = data;
        if (type === _constants.COMPONENT_TYPES.DATE_PICKER_TYPE) {
            sentData = {
                data: data,
                min: _Time2.default.serializeDate(min),
                max: _Time2.default.serializeDate(max)
            };
        }

        return sentData;
    };

    this._onPopupReady = function () {
        var isPopup = _this5.state.isPopup;


        if (isPopup) {
            _this5.openPopupResolved && _this5.openPopupResolved();
            Wix.PubSub.unsubscribe(_this5._getMessageType(_constants.POPUP_EVENTS.POPUP_READY_MESSAGE), _this5._onPopupReady);
            (0, _jquery2.default)(window).on('resize', _this5._onResize);
        }

        _this5.props.onLoad();
    };

    this._onPanelReady = function () {
        var onOpen = _this5.props.onOpen;

        Wix.PubSub.unsubscribe(_this5._getMessageType(_constants.POPUP_EVENTS.PANEL_READY_MESSAGE), _this5._onPanelReady);
        onOpen();
        _this5.setState({ panelReady: true });
    };

    this._requestClosePanel = function () {
        var _state4 = _this5.state,
            isPopup = _state4.isPopup,
            isOpen = _state4.isOpen;


        if (isPopup) {
            Wix.PubSub.publish(_this5._getMessageType(_constants.POPUP_EVENTS.CLOSE_PANEL_MESSAGE), { close: true });
        }

        if (isOpen) {
            _this5._closePanel();
        } else {
            (0, _jquery2.default)(document).off('keyup', _this5._onPanelKeyUp);
        }
    };

    this._onPanelClose = function (_ref) {
        var data = _ref.data;
        var isPopup = _this5.state.isPopup;
        var onChange = _this5.props.onChange;


        if (isPopup) {
            Wix.PubSub.unsubscribe(_this5._getMessageType(_constants.POPUP_EVENTS.PANEL_CLOSING_MESSAGE), _this5._onPanelClose);
        }

        onChange(_this5._getValue(data));
        _this5._closePanel();
    };

    this._closePanel = function () {
        var onClose = _this5.props.onClose;

        _this5._removeDocumentClickListener();
        _this5.setState({ isOpen: false, panelReady: false });
        _this5._focusElement();
        onClose();
    };

    this._enforceClose = function (uniqueId) {
        var isOpen = _this5.state.isOpen;


        if (isOpen && uniqueId !== _this5.uniqueId) {
            _this5._requestClosePanel();
        }
    };

    this._onResize = function () {
        clearTimeout(_this5.resizeTimeout);
        _this5._requestClosePanel();

        _this5.resizeTimeout = setTimeout(function () {
            _this5._reset();
        }, 1000);
    };

    this._focusElement = function () {
        window.focus();
        setTimeout(function () {
            return _this5.field && _this5.field.focus();
        }, 200);
    };

    this._getValue = function (data) {
        var _props12 = _this5.props,
            type = _props12.type,
            value = _props12.value;

        var result = value;

        if (data.value) {
            switch (type) {
                case _constants.COMPONENT_TYPES.DATE_PICKER_TYPE:
                    result = data.value;
                    break;
                case _constants.COMPONENT_TYPES.SELECT_TYPE:
                    result = data.value;
                    break;
            }
        }

        return result;
    };

    this._getPopupUrl = function () {
        var _props13 = _this5.props,
            type = _props13.type,
            rtl = _props13.rtl,
            isHebrew = _props13.isHebrew,
            timezone = _props13.timezone,
            locale = _props13.locale;

        var wixParams = _this5._getWixParams();
        var params = _lodash2.default.map(_extends({
            uniqueId: '' + _this5.uniqueId,
            panelType: type,
            rtl: '' + rtl,
            isHebrew: '' + isHebrew === 'true',
            wixStyleId: _this5.wixStyleId,
            timezone: timezone,
            appLocale: locale
        }, wixParams), function (v, k) {
            return v ? k + '=' + decodeURIComponent(v) : '';
        });
        return (_this5.props.forceUrl || _constants.BASE_DROPDOWN_URL) + '?' + params.join('&');
    };

    this._getWixStyleId = function () {
        return new Promise(function (resolve, reject) {
            try {
                Wix.Styles.getStyleId(function (styleId) {
                    resolve(styleId);
                });
            } catch (e) {
                reject('');
            }
        });
    };

    this._reset = function () {
        var isPopup = _this5.state.isPopup;

        if (isPopup) {
            _this5._closePopup();
            _this5.timeoutId = setTimeout(function () {
                _this5.uniqueId = _this5._generateUniqueId();
                _this5._openPopup();
            }, 200);
        }
    };

    this._openPopup = function () {
        var popupCount = _this5.state.popupCount;
        var type = _this5.props.type;


        if (popupCount > 0) {
            return;
        }

        _this5.setState({ popupCount: 1 });

        if (!_this5._isMobile()) {
            _this5.popupPromise = new Promise(function (resolve, reject) {
                var element = (0, _jquery2.default)(_this5.el);
                var elementWidth = element.outerWidth();
                var width = _this5._getComponentWidth(type, elementWidth);

                var _getPosition = _this5._getPosition(width),
                    top = _getPosition.top,
                    left = _getPosition.left;

                var url = _this5._getPopupUrl();
                var height = 0;
                var position = {
                    origin: Wix.WindowOrigin.ABSOLUTE,
                    placement: Wix.WindowPlacement.BOTTOM_LEFT,
                    x: left,
                    y: top
                };
                var theme = Wix.Theme.BARE;
                _this5.openPopupResolved = resolve;
                Wix.PubSub.subscribe(_this5._getMessageType(_constants.POPUP_EVENTS.POPUP_READY_MESSAGE), _this5._onPopupReady);

                try {
                    console.log('[Dropdown panel]: opening popup', _this5.uniqueId, Date.now());
                    Wix.openPopup(url, Math.floor(width), height, position, _this5._onClose, theme);
                } catch (e) {
                    _this5.setState({ popupCount: 0 });
                    reject(e);
                }
            }).catch(function () {
                Wix.PubSub.unsubscribe(_this5._getMessageType(_constants.POPUP_EVENTS.POPUP_READY_MESSAGE), _this5._onPopupReady);
                _this5.setState({ popupCount: 0 });
            });
        }
    };

    this._onEditModeChange = function () {
        _this5.setState({ popupCount: 0 }, function () {
            _this5._openPopup();
        });
    };

    this._onPageNavigation = function (params) {
        var isAppOnPage = params.isAppOnPage,
            wasAppOnPage = params.wasAppOnPage;


        if (wasAppOnPage) {
            _this5.setState({ popupCount: 0, isOpen: false, panelReady: false }, function () {
                if (isAppOnPage) {
                    _this5._openPopup();
                }
            });
        } else if (isAppOnPage) {
            _this5._openPopup();
        } else {
            // it seems this is the case where the dropdown is inside a header or footer
            _this5._reset();
        }
    };

    this._getPosition = function (width) {
        var rtl = _this5.props.rtl;

        var element = (0, _jquery2.default)(_this5.el);
        var offset = element.offset();
        var top = element.outerHeight() - (0, _jquery2.default)(window).scrollTop();
        var left = offset.left + width;

        top += offset.top;

        if (rtl) {
            left += element.outerWidth() - width;
        }

        return { top: top, left: left };
    };

    this._getComponentWidth = function (type, elementWidth) {
        return type === _constants.COMPONENT_TYPES.SELECT_TYPE ? elementWidth : Math.max(elementWidth, _constants.PANEL_WIDTH);
    };

    this._closePopup = function () {
        var isPopup = _this5.state.isPopup;


        if (isPopup) {
            Wix.PubSub.publish(_this5._getMessageType(_constants.POPUP_EVENTS.CLOSE_POPUP_MESSAGE), { close: true });
        }

        _this5.setState({ isOpen: false, popupCount: 0, panelReady: false });
    };

    this._onClose = function () {
        (0, _jquery2.default)(window).off('resize', _this5._onResize);
    };

    this._generateUniqueId = function () {
        var id = _this5.props.id;

        return id || '' + Math.random();
    };

    this._getMessageType = function (name) {
        return name + '-' + _this5.uniqueId;
    };

    this._onMount = function () {
        if (_this5.el) {
            var shouldOpenPopup = _this5._shouldOpenPopup();

            if (shouldOpenPopup) {
                if (!_this5.state.openOnClick) {
                    _this5._openPopup();
                }

                Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, function () {
                    return _this5._onEditModeChange();
                });
                Wix.addEventListener(Wix.Events.PAGE_NAVIGATION, function (params) {
                    return _this5._onPageNavigation(params);
                });
                Wix.addEventListener(Wix.Events.DEVICE_TYPE_CHANGED, function () {
                    return _this5._openPopup();
                });
            } else {
                _this5.setState({ isPopup: false });
                _this5.props.onLoad();
            }

            Wix.PubSub.subscribe(_constants.POPUP_EVENTS.ENFORCE_CLOSE_MESSAGE, function (_ref2) {
                var data = _ref2.data;
                return _this5._enforceClose(data.uniqueId);
            });
        } else {
            setTimeout(_this5._onMount, 50);
        }
    };

    this._getWixParams = function (nextProps) {
        var props = nextProps || _this5.props;
        var fieldFill = props['wix-param-field-fill'];
        var fieldFont = props['wix-param-field-font'];
        var fieldColor = props['wix-param-field-color'];
        var fieldBorderWidth = props['wix-param-field-border-width'];
        var wixParams = {};

        if (fieldFill) {
            wixParams.fieldFill = fieldFill;
        }
        if (fieldFont) {
            wixParams.fieldFont = fieldFont;
        }
        if (fieldColor) {
            wixParams.fieldColor = fieldColor;
        }
        if (fieldBorderWidth) {
            wixParams.fieldBorderWidth = fieldBorderWidth;
        }

        return wixParams;
    };

    this._deviceTypeChange = function (_ref3) {
        var deviceType = _ref3.deviceType;

        _this5.setState({ deviceType: deviceType }, _this5._reset);
    };

    this._addDocumentClickListener = function () {
        (0, _jquery2.default)(document.body).on('click', _this5._onDocumentClick);
    };

    this._removeDocumentClickListener = function () {
        (0, _jquery2.default)(document.body).off('click', _this5._onDocumentClick);
    };

    this._onDocumentClick = function (e) {
        var target = (0, _jquery2.default)(e.target);

        if ((!_this5.panel || !(0, _jquery2.default)(_this5.panel).has(target).length) && !(0, _jquery2.default)(_this5.el).has(target).length) {
            _this5._requestClosePanel();
        }
    };

    this._getArias = function () {
        var _state5 = _this5.state,
            isPopup = _state5.isPopup,
            isOpen = _state5.isOpen;
        var _props14 = _this5.props,
            type = _props14.type,
            error = _props14.error,
            required = _props14.required,
            ariaDescribedBy = _props14.ariaDescribedBy;

        var arias = {
            'aria-labelledby': 'site-react-dropdown-label_' + _this5.uniqueId,
            'aria-owns': 'site-react-dropdown-panel_' + _this5.uniqueId,
            'aria-required': required
        };

        switch (type) {
            case _constants.COMPONENT_TYPES.SELECT_TYPE:
                arias.role = isPopup ? 'button' : 'listbox';
                break;
            case _constants.COMPONENT_TYPES.DATE_PICKER_TYPE:
                arias.role = 'button';
                break;
        }

        if (arias.role === 'button') {
            arias['aria-haspopup'] = true;
            arias['aria-expanded'] = isOpen;
            arias['aria-invalid'] = error;
        }

        if (ariaDescribedBy) {
            arias['aria-describedby'] = ariaDescribedBy;
        }

        return arias;
    };
};

exports.default = _class;